import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateFiguritas } from "../../actions/figuritasActions";
import { updateAlbumCollection } from "../../firebase/firestore";

export default function AgregarAutorizado() {
  const emptyState = {
    email: "",
    editar: true,
  };
  const [autorizado, setAutorizado] = useState(emptyState);
  const figuritas = useSelector((state) => state.figuritasReducer.figuritas);
  const dispatch = useDispatch();

  const agregarAutorizado = () => {
    if (autorizado.email === "") {
      return;
    }
    const yaExiste = figuritas.autorizados.find(
      (object) => object.email === autorizado.email
    );

    if (yaExiste) {
      return;
    }

    const autorizados = [...figuritas.autorizados, autorizado];

    const figuritasUpdated = { ...figuritas, autorizados };

    dispatch(updateFiguritas(figuritasUpdated));
    updateAlbumCollection(figuritas.owner, figuritasUpdated);
    setAutorizado(emptyState);
  };

  return (
    <div className="formAgregarContainer">
      <input
        className="inputAgregarAutorizado"
        value={autorizado.email}
        placeholder="Email"
        onChange={(value) => {
          setAutorizado({
            ...autorizado,
            email: value.target.value,
          });
        }}
      />
      <label className="labelAgregarAutorizado">
        <input
          className="checkboxAgregarAutorizado"
          type="checkbox"
          checked={autorizado.editar}
          onChange={(value) => {
            setAutorizado({
              ...autorizado,
              editar: value.target.checked,
            });
          }}
        />
        Puede editar
      </label>
      <button className="buttonAgregarAutorizado" onClick={agregarAutorizado}>
        Agregar
      </button>
    </div>
  );
}
